// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationSettings_cardTitle__Zi7Hg {
  font-size: 22px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0 0 4px;
}
.NotificationSettings_cardHint__2E1x2 {
  font-size: 13px;
  color: var(--dylo-muted);
  margin: 0 0 16px;
  line-height: 1.5;
}

/* ===== Tabla de casillas ===== */
.NotificationSettings_table__unK6H {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--dylo-surface-border);
  border-radius: 12px;
  overflow: hidden;
}

.NotificationSettings_headRow__gO7wK,
.NotificationSettings_row__f56TI {
  display: grid;
  /* Las dos columnas de canal son fijas y angostas: el texto manda, los
     interruptores solo necesitan su ancho. */
  grid-template-columns: 1fr 118px 118px;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
}
.NotificationSettings_headRow__gO7wK {
  background: color-mix(in srgb, var(--dylo-orange) 7%, transparent);
  border-bottom: 1px solid var(--dylo-surface-border);
}
.NotificationSettings_row__f56TI + .NotificationSettings_row__f56TI {
  border-top: 1px solid color-mix(in srgb, var(--dylo-surface-border) 55%, transparent);
}
.NotificationSettings_row__f56TI:hover {
  background: color-mix(in srgb, var(--dylo-orange) 4%, transparent);
}

.NotificationSettings_headEvent__HuY63,
.NotificationSettings_headChannel__BvGSa {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--dylo-muted);
}
.NotificationSettings_headChannel__BvGSa {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
}
/* La columna de correo se apaga cuando la dirección no está verificada: es la
   señal visual de que esa columna todavía no entrega nada. */
.NotificationSettings_headMuted__RF\\+sU {
  opacity: 0.5;
}
/* La etiqueta del encabezado dentro del tooltip conserva el ícono y el texto en línea. */
.NotificationSettings_headLabel__BOIRY {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: default;
}

.NotificationSettings_eventCell__953re {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.NotificationSettings_eventLabel__RmmX1 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--dylo-ink);
}
.NotificationSettings_eventDesc__fRipV {
  font-size: 12px;
  color: var(--dylo-muted);
  line-height: 1.45;
}
.NotificationSettings_tag__6X0XU {
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 1px 6px;
  border-radius: 999px;
  color: var(--dylo-muted);
  border: 1px solid color-mix(in srgb, var(--dylo-muted) 45%, transparent);
}

.NotificationSettings_switchCell__Ak-hp {
  display: flex;
  justify-content: center;
}

/* ===== Interruptor =====
   Mismo lenguaje que el de "Developer view" del menú de usuario, para que un
   interruptor se vea igual en toda la plataforma. */
.NotificationSettings_switch__W0qZZ {
  position: relative;
  width: 38px;
  height: 21px;
  flex: 0 0 38px;
  border-radius: 999px;
  border: 1px solid var(--dylo-surface-border);
  background: color-mix(in srgb, var(--dylo-muted) 22%, transparent);
  cursor: pointer;
  padding: 0;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.NotificationSettings_switchOn__I34md {
  background: color-mix(in srgb, var(--dylo-orange) 55%, transparent);
  border-color: color-mix(in srgb, var(--dylo-orange) 70%, transparent);
}
/* Sin guardar: el contorno lo marca. Sin esta pista, alguien puede tocar tres
   casillas, irse de la pantalla y creer que quedaron guardadas. */
.NotificationSettings_switchDirty__l5SZ- {
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--dylo-orange) 35%, transparent);
}
.NotificationSettings_knob__A0gPN {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.15s ease;
}
.NotificationSettings_switchOn__I34md .NotificationSettings_knob__A0gPN {
  transform: translateX(17px);
}
/* Bloqueado hasta verificar el correo. Se marca con aria-disabled y no con
   disabled para que siga recibiendo el foco y el ratón: así el tooltip que
   explica por qué está bloqueado llega a los dos. */
.NotificationSettings_switchLocked__iciB5 {
  cursor: not-allowed;
  opacity: 0.45;
}
.NotificationSettings_switchLocked__iciB5 .NotificationSettings_knob__A0gPN {
  background: color-mix(in srgb, #fff 70%, var(--dylo-muted));
}

/* ===== Avisos ===== */
.NotificationSettings_notice__3Qhp- {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 14px;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.45;
  margin-bottom: 14px;
}
.NotificationSettings_noticeOk__pgzK6 {
  color: var(--dylo-success);
  background: color-mix(in srgb, var(--dylo-success) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--dylo-success) 40%, transparent);
}
.NotificationSettings_noticeError__t\\+aP6 {
  color: var(--dylo-danger);
  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 40%, transparent);
}
.NotificationSettings_noticeWarn__1ANEZ {
  color: var(--dylo-ink);
  background: color-mix(in srgb, var(--dylo-orange) 14%, transparent);
  border: 1px solid color-mix(in srgb, var(--dylo-orange) 45%, transparent);
}

.NotificationSettings_actions__Tmawa {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 14px;
}
.NotificationSettings_dirtyHint__hL0uk {
  font-size: 12px;
  color: var(--dylo-muted);
}

@media (max-width: 700px) {
  .NotificationSettings_headRow__gO7wK,
  .NotificationSettings_row__f56TI {
    grid-template-columns: 1fr 78px 78px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Profile/NotificationSettings.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb;6CAC2C;EAC3C,sCAAsC;EACtC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kEAAkE;EAClE,mDAAmD;AACrD;AACA;EACE,qFAAqF;AACvF;AACA;EACE,kEAAkE;AACpE;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;AACA;6DAC6D;AAC7D;EACE,YAAY;AACd;AACA,yFAAyF;AACzF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;oDAEoD;AACpD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,4CAA4C;EAC5C,kEAAkE;EAClE,eAAe;EACf,UAAU;EACV,0DAA0D;AAC5D;AACA;EACE,mEAAmE;EACnE,qEAAqE;AACvE;AACA;kEACkE;AAClE;EACE,6EAA6E;AAC/E;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;;oDAEoD;AACpD;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,2DAA2D;AAC7D;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,oEAAoE;EACpE,0EAA0E;AAC5E;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,yEAAyE;AAC3E;AACA;EACE,sBAAsB;EACtB,mEAAmE;EACnE,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,oCAAoC;EACtC;AACF","sourcesContent":[".cardTitle {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0 0 4px;\n}\n.cardHint {\n  font-size: 13px;\n  color: var(--dylo-muted);\n  margin: 0 0 16px;\n  line-height: 1.5;\n}\n\n/* ===== Tabla de casillas ===== */\n.table {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--dylo-surface-border);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.headRow,\n.row {\n  display: grid;\n  /* Las dos columnas de canal son fijas y angostas: el texto manda, los\n     interruptores solo necesitan su ancho. */\n  grid-template-columns: 1fr 118px 118px;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 14px;\n}\n.headRow {\n  background: color-mix(in srgb, var(--dylo-orange) 7%, transparent);\n  border-bottom: 1px solid var(--dylo-surface-border);\n}\n.row + .row {\n  border-top: 1px solid color-mix(in srgb, var(--dylo-surface-border) 55%, transparent);\n}\n.row:hover {\n  background: color-mix(in srgb, var(--dylo-orange) 4%, transparent);\n}\n\n.headEvent,\n.headChannel {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: var(--dylo-muted);\n}\n.headChannel {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: center;\n}\n/* La columna de correo se apaga cuando la dirección no está verificada: es la\n   señal visual de que esa columna todavía no entrega nada. */\n.headMuted {\n  opacity: 0.5;\n}\n/* La etiqueta del encabezado dentro del tooltip conserva el ícono y el texto en línea. */\n.headLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  cursor: default;\n}\n\n.eventCell {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n.eventLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n}\n.eventDesc {\n  font-size: 12px;\n  color: var(--dylo-muted);\n  line-height: 1.45;\n}\n.tag {\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border-radius: 999px;\n  color: var(--dylo-muted);\n  border: 1px solid color-mix(in srgb, var(--dylo-muted) 45%, transparent);\n}\n\n.switchCell {\n  display: flex;\n  justify-content: center;\n}\n\n/* ===== Interruptor =====\n   Mismo lenguaje que el de \"Developer view\" del menú de usuario, para que un\n   interruptor se vea igual en toda la plataforma. */\n.switch {\n  position: relative;\n  width: 38px;\n  height: 21px;\n  flex: 0 0 38px;\n  border-radius: 999px;\n  border: 1px solid var(--dylo-surface-border);\n  background: color-mix(in srgb, var(--dylo-muted) 22%, transparent);\n  cursor: pointer;\n  padding: 0;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.switchOn {\n  background: color-mix(in srgb, var(--dylo-orange) 55%, transparent);\n  border-color: color-mix(in srgb, var(--dylo-orange) 70%, transparent);\n}\n/* Sin guardar: el contorno lo marca. Sin esta pista, alguien puede tocar tres\n   casillas, irse de la pantalla y creer que quedaron guardadas. */\n.switchDirty {\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--dylo-orange) 35%, transparent);\n}\n.knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: #fff;\n  transition: transform 0.15s ease;\n}\n.switchOn .knob {\n  transform: translateX(17px);\n}\n/* Bloqueado hasta verificar el correo. Se marca con aria-disabled y no con\n   disabled para que siga recibiendo el foco y el ratón: así el tooltip que\n   explica por qué está bloqueado llega a los dos. */\n.switchLocked {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n.switchLocked .knob {\n  background: color-mix(in srgb, #fff 70%, var(--dylo-muted));\n}\n\n/* ===== Avisos ===== */\n.notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 11px 14px;\n  border-radius: 12px;\n  font-size: 13px;\n  line-height: 1.45;\n  margin-bottom: 14px;\n}\n.noticeOk {\n  color: var(--dylo-success);\n  background: color-mix(in srgb, var(--dylo-success) 12%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dylo-success) 40%, transparent);\n}\n.noticeError {\n  color: var(--dylo-danger);\n  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 40%, transparent);\n}\n.noticeWarn {\n  color: var(--dylo-ink);\n  background: color-mix(in srgb, var(--dylo-orange) 14%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dylo-orange) 45%, transparent);\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 14px;\n  margin-top: 14px;\n}\n.dirtyHint {\n  font-size: 12px;\n  color: var(--dylo-muted);\n}\n\n@media (max-width: 700px) {\n  .headRow,\n  .row {\n    grid-template-columns: 1fr 78px 78px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardTitle": `NotificationSettings_cardTitle__Zi7Hg`,
	"cardHint": `NotificationSettings_cardHint__2E1x2`,
	"table": `NotificationSettings_table__unK6H`,
	"headRow": `NotificationSettings_headRow__gO7wK`,
	"row": `NotificationSettings_row__f56TI`,
	"headEvent": `NotificationSettings_headEvent__HuY63`,
	"headChannel": `NotificationSettings_headChannel__BvGSa`,
	"headMuted": `NotificationSettings_headMuted__RF+sU`,
	"headLabel": `NotificationSettings_headLabel__BOIRY`,
	"eventCell": `NotificationSettings_eventCell__953re`,
	"eventLabel": `NotificationSettings_eventLabel__RmmX1`,
	"eventDesc": `NotificationSettings_eventDesc__fRipV`,
	"tag": `NotificationSettings_tag__6X0XU`,
	"switchCell": `NotificationSettings_switchCell__Ak-hp`,
	"switch": `NotificationSettings_switch__W0qZZ`,
	"switchOn": `NotificationSettings_switchOn__I34md`,
	"switchDirty": `NotificationSettings_switchDirty__l5SZ-`,
	"knob": `NotificationSettings_knob__A0gPN`,
	"switchLocked": `NotificationSettings_switchLocked__iciB5`,
	"notice": `NotificationSettings_notice__3Qhp-`,
	"noticeOk": `NotificationSettings_noticeOk__pgzK6`,
	"noticeError": `NotificationSettings_noticeError__t+aP6`,
	"noticeWarn": `NotificationSettings_noticeWarn__1ANEZ`,
	"actions": `NotificationSettings_actions__Tmawa`,
	"dirtyHint": `NotificationSettings_dirtyHint__hL0uk`
};
export default ___CSS_LOADER_EXPORT___;
